<template>
	<div>
		<StorageList :allowUpload="true" :folder="projectFolder" :folders="['admin', 'client']"></StorageList>	
	</div>
	
</template>
<script>
	import StorageList from "../../components/tools/StorageList.vue"
	export default {
		name: "EditProjectDownloads",
		props: {
			project: {type: Object }
		},
		data: () => {
			return {
			}
		},
		components: {
			StorageList: StorageList
		},
		computed:{
			projectFolder(){
				return "projects/"+this.project.id
			}
		}
	}
</script>